module.exports = __webpack_public_path__ + "6b8e379a6598438f997d0205c1c4366b.png";